import { render, staticRenderFns } from "./safety_status.vue?vue&type=template&id=2f8c7b9e"
import script from "./safety_status.vue?vue&type=script&lang=js"
export * from "./safety_status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports